module.exports = __webpack_public_path__ + "img/check-mark-green.47276c75.svg";